<template>
    <div id="app">
        <Header></Header>
        <Hero image="/static/img/contact-us-image.jpg?"></Hero>
        <Contact></Contact>
        <Footer></Footer>
    </div>


</template>

<script>

    import Header from "./components/Header";
    import Footer from "./components/Footer";
    import Hero from "./components/Hero";
    import BlockC from "./components/BlockC";
    import Services from "./components/Services";
    import Contact from "./components/Contact";

    export default {
        name: 'app',

        data: () => ({}),
        components: {
            Contact,
            Services,
            BlockC,
            Hero,
            Footer,
            Header,


        }
    }
</script>
